import React, { useState } from "react";
import { api } from "../../../software/api";
import { toast } from "sonner";
import { firstName, sameName } from "./boardUtils";

export const RotaPopover = ({ date, current, staff, onClose, onSaved }) => {
  const [sel, setSel] = useState(staff.filter((s) => current.some((c) => sameName(c, s))));
  const toggle = (s) => setSel((p) => (p.includes(s) ? p.filter((x) => x !== s) : [...p, s]));
  const save = async (staffList) => {
    try { await api("POST", "/board/rota", { date, staff: staffList }); toast.success("Saturday rota updated"); onSaved(); }
    catch (e) { toast.error(e.message); }
  };
  return (
    <div className="absolute right-0 top-full z-40 mt-1 w-52 rounded-xl bg-white text-slate-800 shadow-2xl border border-slate-200 p-3 normal-case tracking-normal text-left" data-testid="rota-popover" onClick={(e) => e.stopPropagation()}>
      <p className="text-xs font-black mb-2">Who's in the shop?</p>
      {staff.map((s) => (
        <label key={s} className="flex items-center gap-2 text-xs font-semibold py-0.5 cursor-pointer">
          <input type="checkbox" checked={sel.includes(s)} onChange={() => toggle(s)} data-testid={`rota-check-${firstName(s).toLowerCase()}`} /> {s}
        </label>
      ))}
      <div className="flex gap-1.5 mt-2">
        <button onClick={() => save(null)} data-testid="rota-reset-btn" className="flex-1 rounded-full border border-slate-200 text-[11px] font-bold py-1 hover:bg-slate-50">Default</button>
        <button onClick={onClose} className="flex-1 rounded-full border border-slate-200 text-[11px] font-bold py-1 hover:bg-slate-50">Cancel</button>
        <button onClick={() => save(sel)} data-testid="rota-save-btn" className="flex-1 rounded-full bg-slate-900 text-white text-[11px] font-bold py-1">Save</button>
      </div>
    </div>
  );
};
